<template>
    <div>
        <detailEmploye :admin="false" :showEmpl="showEmp" :idUserCont="idUser" ></detailEmploye>
    </div>
</template>

<script>
    import detailEmploye  from "@/components/resourceHumaine/detail_employe"

    export default
    {
        components:{detailEmploye},
        name: "boardEmploye",
        data(){
            return {
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,

                showEmp: false,
                idUser: null


            }
        },
        mounted(){
            this.showEmp =  true;
            this.idUser =  this.user.id;
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/boardEmploye.vue